export default {
	search(params, cb) {
		this.http
			.get('/stamp/search', {
				params
			})
			.then((r) => cb && cb(r))
	},
	update(form, cb, ecb) {
		this.http
			.post('/stamp/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchStampUser(params, cb) {
		this.http
			.get('/stamp/searchStampUser/full', {
				params
			})
			.then((r) => cb && cb(r))
	},
	statusStampUser(id, to, cb, ecb) {
		this.http
			.get(`/stamp/statusStampUser/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getStampUserById(puid, cb, ecb) {
		this.http
			.get(`/stamp/getStampUserById/${puid}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getStampCards(params, cb, ecb) {
		this.http
			.get(
				`/stamp/getStampUsers/${params.status}/${params.pageno}/${params.pagesize}`,
				{}
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb, prof = '') {
		this.http
			.get(`/stamp/getById/${id}/${prof}`, {})
			.then((r) => cb && cb(r))
	},
	apply(id, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/apply/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	send(pid, uids, qty, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/send/${pid}/${uids}/${qty}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(pid, tostatus, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/status/${pid}/${tostatus}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(puid, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/removeStampUser/${puid}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	activate(puid, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/activate/${puid}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	deactivate(puid, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/deactivate/${puid}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	complete(suid, cb, ecb) {
		this.http
			.get(`/stamp/complete/${suid}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	mark(puid, qty, cb, config = {}, ecb = null) {
		this.http
			.get(`/stamp/mark/${puid}/${qty}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getLog(puid, params, cb) {
		this.http.get(`/stamp/getLog/${puid}`, params).then((r) => cb && cb(r))
	}
}
